import React, { useContext, useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import { getSchoolsAcceptanceStats } from '../../../services/ExtraAllowedStudents/ExtraAllowedStudentsService';
import { ExamYearContext } from '../../../utils/contexts/ExamYearContext';
import { Button } from '../../../components/forms/Buttons/Button';
import { EyeIcon } from '@heroicons/react/24/outline';
import SimpleLoader from '../../../components/Loader/SimpleLoader';

const AcceptedStudentsStats = () => {
  const { examYear } = useContext(ExamYearContext);

  const [schoolStatistics, setSchoolStatistics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (examYear?.uuid) {
      setLoading(true);
      getSchoolsAcceptanceStats({
        page_size: 100,
        exam_year: examYear?.uuid,
      })
        .then((res) => {
          setSchoolStatistics(
            res.map((e) => ({
              ...e,
              available: e.limit - e.accepted,
              available_asp: e.limit_asp - e.accepted_asp,
            })),
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }

    return () => {};
  }, [examYear?.uuid]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'school_id',
      },
      {
        Header: 'Название',
        accessor: 'name',
      },
      {
        Header: 'NOT ASP',
        headerClass: 'bg-blue-200',
        columns: [
          {
            Header: 'Limit',
            accessor: 'limit',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'Accepted',
            accessor: 'accepted',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            id: 'available',
            Header: 'Available',
            accessor: 'available',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'Declined',
            accessor: 'declined',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'All Declined',
            accessor: 'all_declined',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },

          {
            Header: 'Extra',
            accessor: 'extra_students_count',

            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
        ].map((p) => ({ ...p, headerClass: 'bg-blue-200' })),
      },
      {
        headerClass: 'bg-green-200',
        Header: 'ASP',
        columns: [
          {
            Header: 'Limit',
            accessor: 'limit_asp',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'Accepted',
            accessor: 'accepted_asp',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'Available',
            accessor: 'available_asp',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'Declined',
            accessor: 'declined_asp',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
          {
            Header: 'All Declined',
            accessor: 'all_declined_asp',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },

          {
            Header: 'Extra',
            accessor: 'extra_students_asp_count',
            Cell: (props) => <div className='text-center'>{props.value}</div>,
          },
        ].map((p) => ({ ...p, headerClass: 'bg-green-200' })),
      },

      {
        Header: '',
        accessor: 'uuid',
        Cell: (props) => (
          <div className='text-center'>
            <a
              href={`/school-acceptance-stats/${props.row.original.uuid}?year=${examYear?.uuid}`}
              target='_blank'
              rel='noreferrer'
            >
              <Button Icon={EyeIcon} className='max-h-6' />
            </a>
          </div>
        ),
      },
    ],
    [examYear?.uuid],
  );

  if (loading) {
    return (
      <div className='flex h-full w-full items-center justify-center p-12'>
        <SimpleLoader className={'h-14 w-14'} />
      </div>
    );
  }

  return (
    <div className='flexflex-col gap-4'>
      <Table columns={columns} data={schoolStatistics} isSticky />
    </div>
  );
};

export default AcceptedStudentsStats;
